import pullAll from './pullAll'
export default function pullAllBy(data, values, iteratee) {
  return pullAll(data, values, iteratee)
}
